import { professional } from "@/config/professional";

export default function FloatingWhatsApp() {
  return (
    <a
      href={professional.whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Agendar avaliação pelo WhatsApp"
      className="group fixed bottom-[calc(env(safe-area-inset-bottom,0px)+1rem)] right-4 z-40 flex items-center rounded-full bg-[#25D366] text-white shadow-none transition-transform duration-300 hover:-translate-y-0.5 md:bottom-[calc(env(safe-area-inset-bottom,0px)+1.5rem)] md:right-6"
    >
      <span className="flex h-12 w-12 items-center justify-center md:h-14 md:w-14">
        <i className="ri-whatsapp-line text-xl md:text-2xl" aria-hidden="true"></i>
      </span>
      <span className="max-w-0 overflow-hidden whitespace-nowrap text-sm font-semibold opacity-0 transition-all duration-300 group-hover:max-w-[180px] group-hover:pr-6 group-hover:opacity-100">
        Agendar avaliação
      </span>
    </a>
  );
}